import React from "react";
import "../../../styles/ToDoList.css";
import { withNamespaces } from 'react-i18next'; 

const Locais = ({t}) => {
  return (
    <>
      <div className="col-12 col-lg locaisCard">
        <div id="3" className="fantasmaAncora"></div>
        <div className="card">
          <div id="locais" className="card-body">
            {/* superior */}

            <div className="info">
              <h4 className="title">{t('moduleToDoList:S3.T')}</h4>
            </div>

            {/* inferior */}

            <ul>
              <hr className="divider"></hr>
              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/kSNtmC6e74gFR7U28"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI1')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/TUJKAwXNzftLFDB18"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI2')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/qQVqEKxRVGjMWkcM6"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI3')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/AVJdUSXp16cMfabr8"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI4')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/XqRLCZkkPeWbhe176"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI5')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/baqjwe8M1iU6NPp6A"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI6')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/zrwxbJbYYtooaygX6"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI7')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>

              <hr className="divider"></hr>

              <li>
                {/* <button
                  className="check_button"
                  type="button"
                >
                  <i
                    className="fas fa-check-circle"></i>
                </button> */}
                <a
                  href="https://goo.gl/maps/oHaeNwJb8ztwcEnd9"
                  target="_blank"
                  rel="noreferrer"
                  className="right mx-auto"
                >
                  <p className="mt-1">{t('moduleToDoList:S3.UL.LI8')}</p>
                  <div className="arrow-color">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default withNamespaces() (Locais);
